'use strict';

import { Component } from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';

const RemoveButton = ({ onClick }) => (
	<button
		type="button"
		className="relative py-0.5 px-1 m-0 text-gray-500 bg-transparent rounded-md hover:text-red-500 hover:bg-red-100"
		aria-label="Close"
		onClick={ onClick }
	>
		<span className="sr-only">Remove</span>
		<Icon icon={ faTimes } className="size-3" />
	</button>
);

const Pill = ({ label, onRemove }) => (
	<div className="flex flex-wrap items-center pr-0.5">
		<div className="inline-flex gap-x-0.5 justify-center items-center py-0.5 pl-2 text-xs">
			<span className="text-gray-600">{ label }</span>
			<RemoveButton onClick={ onRemove } />
		</div>
	</div>
);

const PillGroup = ({ label, items }) => (
	<div className="flex flex-wrap items-center rounded-lg border divide-x">
		{ label && (
			<div className="py-0.5 px-2 text-xs font-semibold">{ label }</div>
		) }
		{ items.map(item => (
			<Pill key={ item.label } label={ item.label } onRemove={ item.onRemove } />
		)) }
	</div>
);

class CurrentRefinements extends Component {
	render() {
		const { items, refine } = this.props;
		const seen = [];
		
		if (! items.length) {
			return null;
		}
		
		return (
			<div className="overflow-hidden mb-4 bg-white rounded-lg border-2">
				<div className="flex justify-between items-center py-3 px-4 m-0 text-lg text-gray-700 bg-gray-50 border-b">
					<span className="font-condensed">
						Active Filters
					</span>
					<button
						type="button"
						className="btn btn-blue btn-sm btn-link"
						onClick={ () => refine(items) }
					>
						Clear All
					</button>
				</div>
				<div className="flex flex-wrap gap-2 items-center p-2">
					{ items.filter(item => {
						if (-1 === seen.indexOf(item.attribute)) {
							seen.push(item.attribute);
							return true;
						}
						return false;
					}).map(item => {
						if ("course_status" === item.attribute) {
							item.label = 'Course Status';
							item.items = [{ label: item.currentRefinement, value: item.value }];
						} else if ("approvals.generic_name" === item.attribute) {
							item.label = 'Approved By';
						} else if (item.attribute.startsWith('approval_levels.')) {
							item.label = 'Approved By';
							item.items = [{ label: item.currentRefinement.replaceAll(' > ', ' ▸ '), value: item.value }];
						} else if ("approvals.department_type" === item.attribute) {
							item.label = 'Approval Types';
						} else {
							item.label = item.attribute.charAt(0).toUpperCase() + item.attribute.slice(1).toLowerCase();
						}
						
						return item;
					}).map(item => {
						if (item.items) {
							return (
								<PillGroup
									key={ item.label }
									label={ item.label }
									items={ item.items.map(nested_item => ({
										label: nested_item.label,
										onRemove: () => refine(nested_item.value),
									})) }
								/>
							);
						}
						
						if ("cpi_requirement" === item.attribute) {
							item.label = 'Required for CPI® certification';
						} else if ("available_to_non_members" === item.attribute) {
							item.label = 'Free to guests';
						}
						
						return (
							<PillGroup
								key={ item.attribute }
								items={ [item].map(item => ({
									label: item.label.replaceAll('_', ' '),
									onRemove: () => refine(item.value),
								})) }
							/>
						);
					}) }
				</div>
			</div>
		);
	}
}

export default connectCurrentRefinements(CurrentRefinements);
